export default __webpack_public_path__ + "static/josh-2022-e97e09a83d6870ef5903580772f5c0a9.png";